function contactWidget() {
	const widgetTrigger = document.querySelector(
		'[data-js="contact-widget-trigger"]'
	);

	if (widgetTrigger) {
		const widget = document.querySelector('[data-js="contact-widget"]');
		const widgetConfirm = widget.querySelector(
			'[data-js="contact-widget-confirm"]'
		);
		const widgetForm = widget.querySelector('[data-js="contact-widget-form"]');
		const widgetConfirmCloseBtn = widgetConfirm.querySelector(
			'[data-js="close-widget-confirm"]'
		);
		const widgetFormCloseBtn = widgetForm.querySelector(
			'[data-js="close-widget-form"]'
		);
		const showFormBtn = widgetConfirm.querySelector(
			'[data-js="show-contact-form"]'
		);
		const formContactBtnMobile = widgetForm.querySelector(
			'[data-js="contact-mobile"]'
		);
		const formContactBtnDesktop = widgetForm.querySelector(
			'[data-js="contact-desktop"]'
		);

		if (!checkIsMobile()) {
			if (!sessionStorage.getItem("widget")) {
				setTimeout(() => {
					_showPopup(widgetConfirm, widgetForm, widgetTrigger);
				}, 2000);
			} else {
				setTimeout(() => {
					widgetTrigger.classList.add("active");
				}, 5000);
			}
		} else {
			setTimeout(() => {
				widgetTrigger.classList.add("active");
			}, 5000);
		}

		widgetTrigger.addEventListener("click", () => {
			_showPopup(widgetForm, widgetConfirm, widgetTrigger);
		});

		widgetConfirmCloseBtn.addEventListener("click", () => {
			_closePopup(widgetConfirm, widgetTrigger);
			setTimeout(() => {
				widgetTrigger.classList.add("active");
			}, 5000);
		});
		widgetFormCloseBtn.addEventListener("click", (e) => {
			e.preventDefault();
			_closePopup(widgetForm, widgetTrigger);
		});

		showFormBtn.addEventListener("click", () => {
			_showPopup(widgetForm, widgetConfirm, widgetTrigger);
		});

		if (checkIsMobile()) {
			formContactBtnMobile.classList.remove("is-hidden");
		} else {
			formContactBtnDesktop.classList.remove("is-hidden");
		}
	}
}

function _showPopup(popup, otherPopup, trigger) {
	trigger.classList.remove("active");
	popup.classList.add("is-shown");
	otherPopup.classList.remove("is-shown");
}

function _closePopup(popup, trigger) {
	trigger.classList.remove("active");
	popup.classList.remove("is-shown");
	sessionStorage.setItem("widget", "true");
}

export default contactWidget;
